import React from 'react';
import { Facebook, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#2a1a0f] py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[#f4ead4] flex items-center justify-center">
              <span className="text-[#2a1a0f] font-serif text-lg">B</span>
            </div>
            <span className="font-serif text-[20px] text-[#f4ead4]">Bliss Coffee</span>
          </div>

          <div className="flex flex-col sm:flex-row gap-5 sm:gap-8 text-[14px] text-[#c9b394]">
            <a
              href="https://www.google.com/maps/search/?api=1&query=462+B+Anderson+Dr,+Quesnel,+BC+V2J+1G2"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 hover:text-[#f4ead4] transition-colors"
            >
              <MapPin className="w-4 h-4" strokeWidth={1.8} />
              462 B Anderson Dr, Quesnel, BC
            </a>
            <a
              href="tel:+12509927066"
              className="inline-flex items-center gap-2 hover:text-[#f4ead4] transition-colors"
            >
              <Phone className="w-4 h-4" strokeWidth={1.8} />
              (250) 992-7066
            </a>
          </div>

          <div className="flex items-center gap-4">
            <span className="text-[13px] text-[#c9b394] hidden sm:inline">Follow us</span>
            <a
              href="https://www.facebook.com/AndersonDriveQuesnel.bc"
              target="_blank"
              rel="noreferrer"
              aria-label="Follow Bliss Coffee on Facebook"
              className="inline-flex items-center gap-2 bg-[#f4ead4] hover:bg-[#ecdcbf] text-[#2a1a0f] px-4 py-2.5 rounded-full transition-colors"
            >
              <Facebook className="w-4 h-4 fill-[#2a1a0f]" strokeWidth={0} />
              <span className="text-[14px] font-medium">Facebook</span>
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[#f4ead4]/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-[12px] text-[#c9b394]/70">
          <span>&copy; {new Date().getFullYear()} Bliss Coffee &middot; Quesnel, BC</span>
          <span>Website created by Laith Elmradi</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
